<template>
  <div class="wrapper">
    <div class="HeaderTop">
      <div class="contentTop">
        <div class="factoryName">
          <img src="~assets/caiLogo.png" alt="" /><span
            style="padding-left: 10px"
            >浙江才府玻璃-数字化工厂 (德清二厂)</span
          >
        </div>
        <div class="input">
          <div class="stove"><span>窑炉:</span></div>
          <div>
            <a-select
              default-value="3"
              style="width: 120px"
              @change="handleChange"
            >
              <a-select-option value="3"> 3号窑炉 </a-select-option>
              <a-select-option value="5"> 5号窑炉 </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="dateInfo">
          <div class="title">{{ date }}</div>
          <div class="time">{{ time }}</div>
          <div style="display;flex;align-items: center;">
            <div style="display: flex">
              <a-button
                class="fullbutton"
                @click="fullScreen"
                size="small"
                v-show="!screenFlag"
                ><a-icon type="fullscreen" /></a-button
              ><a-button
                class="smallbutton"
                @click="smallScreen"
                size="small"
                v-show="screenFlag"
                ><a-icon type="fullscreen"
              /></a-button>
              <a-button class="fullbutton" size="small" @click="toPage">
                <a-icon type="reload" />
              </a-button>
            </div>
          </div>
        </div>
      </div>
      <div class="img">
        <img src="~assets/img/background.png" alt="" />
        <div class="relatedProduct">
          <div class="stone" v-for="item in stoneInfo" :key="item.index">
            <div class="stoneName">{{ item.stoneName }}</div>
            <div class="info">
              <div class="weight">
                <div>{{ item.weight1 }}kg</div>
                <div>{{ item.weight2 }}kg</div>
              </div>
              <div class="type">S<br />P</div>
            </div>
          </div>
        </div>
        <div class="leftMiddle" style="font-weight: bold">
          <div
            class="unit"
            style="color: #f01515; position: absolute; top: 50px; left: 225px"
          >
            {{ info.blank }}坯料/付
          </div>
          <div
            class="mixTime"
            style="
              position: absolute;
              top: 165px;
              left: 250px;
              font-size: 10px;
              width: 25px;
            "
          >
            混料时间
          </div>
          <div
            class="time1"
            style="
              position: absolute;
              top: 200px;
              left: 255px;
              font-size: 10px;
              width: 40px;
            "
          >
            {{ mixingTime.t1 }}秒
          </div>
          <div
            class="time2"
            style="
              position: absolute;
              top: 220px;
              left: 255px;
              font-size: 10px;
              width: 40px;
            "
          >
            {{ mixingTime.t2 }}秒
          </div>
          <div
            class="pressure"
            style="position: absolute; top: 390px; left: 255px; font-size: 10px"
          >
            烟道抽力{{ info.fluePumpingForce }}pa
          </div>
          <div
            class="ferquerycy"
            style="position: absolute; top: 410px; left: 355px; font-size: 10px"
          >
            引风机{{ info.fre }}Hz
          </div>
        </div>
        <div class="leftBottom">
          <div style="position: absolute; top: 20%; left: 22%; height: 25px">
            蒸汽{{ relatedInfomation.steamPress }}Mpa
          </div>
          <div style="position: absolute; top: 28%; left: 19%">
            一次风:{{ relatedInfomation.firstWind }}HZ
          </div>
          <div style="position: absolute; top: 41.5%; left: 21%">
            二次风:{{ relatedInfomation.secondWind }}HZ
          </div>
          <div style="position: absolute; top: 50%; left: 19.8%">SRC</div>
          <div style="position: absolute; top: 47.5%; left: 22%">
            雾化:{{ relatedInfomation.SRC.atomization }}MPa
          </div>
          <div style="position: absolute; top: 53.5%; left: 22%">
            反应:{{ relatedInfomation.SRC.reactionTem }}℃
          </div>
          <div style="position: absolute; top: 60%; left: 19.8%">布袋</div>
          <div style="position: absolute; top: 58.5%; left: 22%">
            喷吹:{{ relatedInfomation.BAG.injectionPress }}MPa
          </div>
          <div style="position: absolute; top: 65.5%; left: 22%">
            反应:{{ relatedInfomation.BAG.reactionTem }}℃
          </div>
          <div style="position: absolute; top: 70.5%; left: 20%">
            氨水用量:{{ relatedInfomation.ammoniaDosage }}g
          </div>
          <div style="position: absolute; top: 75.5%; left: 20%">
            小苏打用量{{ relatedInfomation.bakingsodaDosage }}g
          </div>
        </div>
        <div class="contentMiddle">
          <div
            style="
              width: 105px;
              height: 20px;
              position: absolute;
              background-color: #e2f7ff;
              border: 1px solid #937cfe;
              top: 15%;
              left: 26%;
            "
          >
            饱和蒸汽温度{{ steamTem }}℃
          </div>
          <div
            style="
              width: 125px;
              height: 20px;
              position: absolute;
              background-color: #fff3c5;
              border: 1px solid #f5c252;
              top: 30%;
              left: 26%;
            "
          >
            煤气出口1压力{{ gasExit1.sumPress }}Kpa
          </div>
          <div
            style="
              width: 125px;
              height: 20px;
              position: absolute;
              background-color: #fff3c5;
              border: 1px solid #f5c252;
              top: 73%;
              left: 26%;
            "
          >
            煤气出口2压力{{ gasExit2.sumPress }}Kpa
          </div>
          <div style="position: absolute; top: 52%; left: 26%">
            总烟道{{ mainflue.allTem }}℃
          </div>
        </div>
        <div class="detail">
          <div class="gas1">
            <div class="inanity">
              <div style="color: #fff">西侧空蓄</div>
              <div>上{{ gasExit1.westbare.topTem }}℃</div>
              <div>中{{ gasExit1.westbare.middleTem }}℃</div>
              <div>下{{ gasExit1.westbare.bottomTem }}℃</div>
            </div>
            <div class="kerosence">
              <div style="color: #fff">西侧煤蓄</div>
              <div>上{{ gasExit1.westcoal.topTem }}℃</div>
              <div>中{{ gasExit1.westcoal.middleTem }}℃</div>
              <div>下{{ gasExit1.westcoal.bottomTem }}℃</div>
            </div>
          </div>
          <div class="allGas">
            <div class="inanity1">
              <div style="color: #fff">西侧空蓄</div>
              <div>上{{ mainflue.westbare.topTem }}℃</div>
              <div>中{{ mainflue.westbare.middleTem }}℃</div>
              <div>下{{ mainflue.westbare.bottomTem }}℃</div>
            </div>
            <div class="kerosence1">
              <div style="color: #fff">西侧煤蓄</div>
              <div>上{{ mainflue.westcoal.topTem }}℃</div>
              <div>中{{ mainflue.westcoal.middleTem }}℃</div>
              <div>下{{ mainflue.westcoal.bottomTem }}℃</div>
            </div>
            <div class="inanity2">
              <div style="color: #fff">东侧空蓄</div>
              <div>上{{ mainflue.eastbare.topTem }}℃</div>
              <div>中{{ mainflue.eastbare.middleTem }}℃</div>
              <div>下{{ mainflue.eastbare.bottomTem }}℃</div>
            </div>
            <div class="kerosence2">
              <div style="color: #fff">东侧煤蓄</div>
              <div>上{{ mainflue.eastcoal.topTem }}℃</div>
              <div>中{{ mainflue.eastcoal.middleTem }}℃</div>
              <div>下{{ mainflue.eastcoal.bottomTem }}℃</div>
            </div>
          </div>
          <div class="gas2">
            <div class="inanity3">
              <div style="color: #fff">东侧空蓄</div>
              <div>上{{ gasExit2.eastbare.topTem }}℃</div>
              <div>中{{ gasExit2.eastbare.middleTem }}℃</div>
              <div>下{{ gasExit2.eastbare.bottomTem }}℃</div>
            </div>
            <div class="kerosence3">
              <div style="color: #fff">东侧煤蓄</div>
              <div>上{{ gasExit2.eastcoal.topTem }}℃</div>
              <div>中{{ gasExit2.eastcoal.middleTem }}℃</div>
              <div>下{{ gasExit2.eastcoal.bottomTem }}℃</div>
            </div>
          </div>
          <div class="companyTem">
            <div class="companyText">工作室温度</div>
            <div class="tem1">温度1：{{ workshopTem.tem1 }}℃</div>
            <div class="tem2">温度2：{{ workshopTem.tem2 }}℃</div>
            <div class="west" style="color: #fff">西辐射</div>
          </div>
          <div class="contentMiddle">
            <div class="kilnPress">
              窑压:{{ workshopTem.westRadiation.stovePress }}Pa
            </div>
            <div class="fluidHight">
              液位:{{ workshopTem.westRadiation.fliudHeight }}mm
            </div>
          </div>
          <div class="dissolve">
            <div class="dissolveName">溶解区</div>
            <div class="dissolveDetail">
              <div>炉顶{{ workshopTem.liquefy.stoveTop1 }}℃</div>
              <div>炉底{{ workshopTem.liquefy.stoveBottom1 }}℃</div>
              <div style="width: 51px; background-color: #ffdccd">
                炉底{{ workshopTem.liquefy.stoveBottom2 }}℃
              </div>
            </div>
          </div>
          <div class="clear">
            <div class="clearName">澄清区</div>
            <div class="clearDetail">
              <div>炉顶{{ workshopTem.clarify.stoveTop }}℃</div>
              <div>炉底{{ workshopTem.clarify.stoveBottom }}℃</div>
            </div>
          </div>
          <div class="feedingNum">
            <div class="avefeeding">
              整点出料量<br />
              {{ workshopTem.eastRadiation.feeding }}吨/日
            </div>
            <div class="temNum">
              <div>{{ workshopTem.eastRadiation.tem1 }}℃</div>
              <div>{{ workshopTem.eastRadiation.tem2 }}℃</div>
            </div>
          </div>
          <div class="lastTem">{{ feedTem.sumTem }}℃</div>
          <div class="feedingDetail1">
            <div
              v-for="(item, index) in feedTem.list"
              :key="index"
              :class="`itemFeed${index}`"
            >
              <span style="padding-right: 3px; padding-left: 2px"
                >{{ item.tem1 }}℃</span
              ><span style="padding-right: 3px; padding-left: 2px"
                >{{ item.tem2 }}℃</span
              ><span style="padding-right: 3px; padding-left: 2px"
                >{{ item.tem3 }}℃</span
              ><span style="padding-right: 3px; padding-left: 2px"
                >{{ item.tem4 }}℃</span
              ><span style="padding-right: 3px; padding-left: 2px"
                >{{ item.tem5 }}℃</span
              >
            </div>
          </div>
          <div class="runRev1">
            <div
              v-for="(item, index) in feedTem.rev"
              :key="index"
              :class="`BPM${index}`"
            >
              <span style="padding-left: 10px">{{ item.bpm }}个</span
              ><span style="padding-left: 30px"
                >{{ item.productionNum }}吨</span
              >
            </div>
          </div>
          <div class="currentDetail1">
            <div v-for="(item, index) in stoveTem" :key="index">
              <div :class="`stoveTem${index}`">
                <div style="display: flex">
                  <div style="width: 25px">{{ item.settingTem1 }}</div>
                  <div style="width: 25px">{{ item.settingTem2 }}</div>
                  <div style="width: 25px">{{ item.settingTem3 }}</div>
                  <div style="width: 25px">{{ item.settingTem4 }}</div>
                  <div style="width: 25px">{{ item.settingTem5 }}</div>
                </div>
                <div style="display: flex">
                  <div style="width: 25px">{{ item.currentTem1 }}</div>
                  <div style="width: 25px">{{ item.currentTem2 }}</div>
                  <div style="width: 25px">{{ item.currentTem3 }}</div>
                  <div style="width: 25px">{{ item.currentTem4 }}</div>
                  <div style="width: 25px">{{ item.currentTem5 }}</div>
                </div>
              </div>
              <div :class="`frequency${index}`">
                <div>
                  <div>{{ item.fre }}Hz</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottleWeight">
            <div
              :class="`itemWeight${index}`"
              v-for="(item, index) in bottleWeight"
              :key="index"
            >
              <div style="width: 55px; color: #d47070">
                瓶重:{{ item.weight }}g
              </div>
            </div>
          </div>
          <div class="currentState">
            <div
              :class="`itemState${index}`"
              v-for="(item, index) in states"
              :key="index"
            >
              <div
                style="
                  display: flex;
                  width: 150px;
                  justify-content: space-between;
                "
              >
                <div style="width: 55px; height: 130px">
                  {{ item.states == 1 ? "开机亮灯" : "未知" }}
                </div>
                <div style="width: 55px; height: 130px">
                  {{ item.states == 1 ? "开机亮灯" : "未知" }}
                </div>
              </div>
            </div>
          </div>
          <div class="packingNum">
            <div
              v-for="(item, index) in states"
              :key="index"
              :class="`itempackingNum${index}`"
            >
              <div class="packingName">包装:{{ item.layer }}层</div>
              <div class="packingDetail">一层：{{ item.count }}支</div>
            </div>
          </div>
          <div class="productInfo">
            <div
              v-for="item in productInfo"
              :key="item.index"
              style="height: 95px"
            >
              <div class="productName">{{ item.productionCode }}</div>
              <div class="productDetail">
                <div style="display: flex">
                  <div class="productItem">{{ item.productionName }}</div>
                  <div class="productItem">{{ item.qualifypercent }}%</div>
                </div>
                <div style="display: flex">
                  <div class="productItem">{{ item.productionNum }}个</div>
                  <div class="productItem">{{ item.allNum }}个</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="echartsTable">
      <div class="productEle">
        <productEle
          :value="value"
          v-if="value.length !== 0 || legend.length !== 0"
        ></productEle>
      </div>
      <div class="production">
        <production
          :value="productionValue"
          :axis="productionAxis"
          v-if="productionValue.length !== 0 || productionAxis.length !== 0"
        ></production>
      </div>
      <div class="fracking">
        <fracking :data="data" v-if="data.length !== 0"></fracking>
      </div>
      <div class="info">
        <g2></g2>
      </div>
    </div>
    <!-- <div class="annotation">
      <div>技术支持：杭州制保科技有限公司</div>
      <div style="float: right">
        <a-button class="fullbutton" size="small" @click="toPage">
          <a-icon type="fullscreen" />
        </a-button>
      </div>
    </div> -->
  </div>
</template>
<script>
import {
  getmaterialsWeight,
  getfeedTemp,
  getstoneTemp,
  getbottleWeight,
  getproductionInfo,
  getworkshopTemp,
  getrelatedInfo,
  getflueTemp,
  gethistogram,
  getelectricity,
  getmaterialUse,
} from "../network/glassScreen";
import g2 from "./test10Children/g2.vue";
import relatedInfo from "./test10Children/relatedInfo.vue";
import fracking from "./test10Children/fracking.vue";
import productEle from "./test10Children/productele.vue";
import production from "./test10Children/production.vue";
export default {
  name: "",
  data() {
    return {
      id: "",
      date: "",
      time: "",
      week: "",
      bottleWeight: [],
      states: [],
      stoneInfo: [],
      mixingTime: "",
      feedTem: {},
      stoveTem: [],
      productInfo: [],
      workshopTem: {},
      relatedInfomation: {},
      info: "",
      steamTem: "",
      gasExit1: {},
      mainflue: {},
      gasExit2: {},
      value: [],
      legend: [],
      productionValue: [],
      productionAxis: [],
      screenFlag:false,
      time1: "",
      time2: "",
      time3: "",
      time4: "",
      time5: "",
      time6: "",
      time7: "",
      time8: "",
      time9: "",
      time10: "",
      time11: "",
      time12: "",
      data: "",
    };
  },
  components: {
    productEle,
    production,
    fracking,
    relatedInfo,
    g2,
  },
  created() {
    this.todo();
    this.getmaterialsWeight(3);
    this.getfeedTemp(3);
    this.getstoneTemp(3);
    this.getbottleWeight(3);
    this.getproductionInfo(3);
    this.getworkshopTemp(3);
    this.getrelatedInfo(3);
    this.getflueTemp(3);
    this.gethistogram(3);
    this.getelectricity(3);
    this.getmaterialUse(3);
  },
  mounted() {
    document.addEventListener("fullscreenchange", this.fshandler);
    document.addEventListener("webkitfullscreenchange", this.fshandler);
    document.addEventListener("mozfullscreenchange", this.fshandler);
    document.addEventListener("MSFullscreenChange", this.fshandler);
  },
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.fshandler);
    document.removeEventListener("webkitfullscreenchange", this.fshandler);
    document.removeEventListener("mozfullscreenchange", this.fshandler);
    document.removeEventListener("MSFullscreenChange", this.fshandler);
    this.time1 && clearTimeout(this.time1);
    this.time2 && clearTimeout(this.time2);
    this.time3 && clearTimeout(this.time3);
    this.time4 && clearTimeout(this.time4);
    this.time5 && clearTimeout(this.time5);
    this.time6 && clearTimeout(this.time6);
    this.time7 && clearTimeout(this.time7);
    this.time8 && clearTimeout(this.time8);
    this.time9 && clearTimeout(this.time9);
    this.time10 && clearTimeout(this.time10);
    this.time11 && clearTimeout(this.time11);
    this.time12 && clearTimeout(this.time12);
  },
  methods: {
    toPage() {
      this.$router.push({
        name: "plasticfactory",
      });
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var week = date.getDay();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var Seconds = date.getSeconds();
      this.date = `${year}年 ${month}月 ${day}日`;
      this.time = `${hours}:${minutes}:${Seconds}`;
      var a = ["日", "一", "二", "三", "四", "五", "六"];
      var week = date.getDay();
      this.week = "星期" + a[week];
      // console.log(`${year}-${month}-${day}-${week}-${hours}:${minutes}`);
    },
    getelectricity(id) {
      getelectricity(id).then(
        (res) => {
          if (res.data.code == 200) {
            // console.log(res);
            this.legend = res.data.data.legend;
            this.value = res.data.data.pic;
            this.time9 && clearTimeout(this.time9);
            this.time9 = setTimeout(() => {
              this.getelectricity(id);
            }, 5000);
          } else {
            this.time9 && clearTimeout(this.time9);
            this.time9 = setTimeout(() => {
              this.getelectricity(id);
            }, 5000);
          }
        },
        (err) => {
          this.time9 && clearTimeout(this.time9);
          this.time9 = setTimeout(() => {
            this.getelectricity(id);
          }, 5000);
        }
      );
    },
    todo() {
      setInterval(this.getTime, 500);
    },
    getmaterialUse(id) {
      getmaterialUse(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.productionValue = res.data.data.pic;
            this.productionAxis = res.data.data.axis;
            this.time10 && clearTimeout(this.time10);
            this.time10 = setTimeout(() => {
              this.getmaterialUse(id);
            }, 5000);
          } else {
            this.time10 && clearTimeout(this.time10);
            this.time10 = setTimeout(() => {
              this.getmaterialUse(id);
            }, 5000);
          }
        },
        (err) => {
          this.time10 && clearTimeout(this.time10);
          this.time10 = setTimeout(() => {
            this.getmaterialUse(id);
          }, 5000);
        }
      );
    },
    gethistogram(id) {
      gethistogram(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.data = res.data.data.pic;
            // console.log("gethistogram", res);
            this.fracking();
            this.time11 && clearTimeout(this.time11);
            this.time11 = setTimeout(() => {
              this.gethistogram(id);
            }, 5000);
          } else {
            this.time11 && clearTimeout(this.time11);
            this.time11 = setTimeout(() => {
              this.gethistogram(id);
            }, 5000);
          }
        },
        (err) => {
          this.time11 && clearTimeout(this.time11);
          this.time11 = setTimeout(() => {
            this.gethistogram(id);
          }, 5000);
        }
      );
    },
    fracking() {
      for (let items of this.data) {
        for (let item of items.data) {
          // console.log(item);
          if (item.itemStyle.color == 0) {
            item.itemStyle.color = "#f6ce1d";
          } else if (item.itemStyle.color == 1) {
            item.itemStyle.color = "#5be2ff";
          } else if (item.itemStyle.color == 2) {
            item.itemStyle.color = "#f0817f";
          }
        }
      }
      // console.log('this.data',this.data)
    },
    getflueTemp(id) {
      getflueTemp(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.steamTem = res.data.data.steamTem;
            this.gasExit1 = res.data.data.gasExit1;
            this.gasExit2 = res.data.data.gasExit2;
            this.mainflue = res.data.data.mainflue;
            // console.log(res);
            this.time1 && clearTimeout(this.time1);
            this.time1 = setTimeout(() => {
              this.getflueTemp(id);
            }, 5000);
          } else {
            this.time1 && clearTimeout(this.time1);
            this.time1 = setTimeout(() => {
              this.getflueTemp(id);
            }, 5000);
          }
        },
        (err) => {
          this.time1 && clearTimeout(this.time1);
          this.time1 = setTimeout(() => {
            this.getflueTemp(id);
          }, 5000);
        }
      );
    },
    getrelatedInfo(id) {
      getrelatedInfo(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.relatedInfomation = res.data.data;
            this.time2 && clearTimeout(this.time2);
            this.time2 = setTimeout(() => {
              this.getrelatedInfo(id);
            }, 5000);
          } else {
            this.time2 && clearTimeout(this.time2);
            this.time2 = setTimeout(() => {
              this.getrelatedInfo(id);
            }, 5000);
          }
          // console.log(res);
        },
        (err) => {
          this.time2 && clearTimeout(this.time2);
          this.time2 = setTimeout(() => {
            this.getrelatedInfo(id);
          }, 5000);
        }
      );
    },
    getworkshopTemp(id) {
      getworkshopTemp(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.workshopTem = res.data.data;
            // console.log(res);
            this.time3 && clearTimeout(this.time3);
            this.time3 = setTimeout(() => {
              this.getworkshopTemp(id);
            }, 5000);
          } else {
            this.time3 && clearTimeout(this.time3);
            this.time3 = setTimeout(() => {
              this.getworkshopTemp(id);
            }, 5000);
          }
        },
        (err) => {
          this.time3 && clearTimeout(this.time3);
          this.time3 = setTimeout(() => {
            this.getworkshopTemp(id);
          }, 5000);
        }
      );
    },
    getproductionInfo(id) {
      getproductionInfo(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.productInfo = res.data.data;
            // console.log(res);
            this.time4 && clearTimeout(this.time4);
            this.time4 = setTimeout(() => {
              this.getproductionInfo(id);
            }, 5000);
          } else {
            this.time4 && clearTimeout(this.time4);
            this.time4 = setTimeout(() => {
              this.getproductionInfo(id);
            }, 5000);
          }
        },
        (err) => {
          this.time4 && clearTimeout(this.time4);
          this.time4 = setTimeout(() => {
            this.getproductionInfo(id);
          }, 5000);
        }
      );
    },
    getbottleWeight(id) {
      getbottleWeight(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.bottleWeight = res.data.data.bottleWeight.slice(0, 4);
            this.states = res.data.data.states;
            // console.log(res);
            this.time5 && clearTimeout(this.time5);
            this.time5 = setTimeout(() => {
              this.getbottleWeight(id);
            }, 5000);
          } else {
            this.time5 && clearTimeout(this.time5);
            this.time5 = setTimeout(() => {
              this.getbottleWeight(id);
            }, 5000);
          }
        },
        (err) => {
          this.time5 && clearTimeout(this.time5);
          this.time5 = setTimeout(() => {
            this.getbottleWeight(id);
          }, 5000);
        }
      );
    },
    getstoneTemp(id) {
      getstoneTemp(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.stoveTem = res.data.data;
            this.stoveTem = this.stoveTem.slice(0, 4);
            // console.log(res);
            this.time6 && clearTimeout(this.time6);
            this.time6 = setTimeout(() => {
              this.getstoneTemp(id);
            }, 5000);
          } else {
            this.stoveTem = res.data.data;
            this.stoveTem = this.stoveTem.slice(0, 4);
            // console.log(res);
            this.time6 && clearTimeout(this.time6);
            this.time6 = setTimeout(() => {
              this.getstoneTemp(id);
            }, 5000);
          }
        },
        (err) => {
          this.stoveTem = res.data.data;
          this.stoveTem = this.stoveTem.slice(0, 4);
          // console.log(res);
          this.time6 && clearTimeout(this.time6);
          this.time6 = setTimeout(() => {
            this.getstoneTemp(id);
          }, 5000);
        }
      );
    },
    getmaterialsWeight(id) {
      getmaterialsWeight(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.stoneInfo = res.data.data.stoneList;
            this.mixingTime = res.data.data.mixingTime;
            this.info = res.data.data.info;
            // console.log(res);
            this.time7 && clearTimeout(this.time7);
            this.time7 = setTimeout(() => {
              this.getmaterialsWeight(id);
            }, 5000);
          } else {
            this.time7 && clearTimeout(this.time7);
            this.time7 = setTimeout(() => {
              this.getmaterialsWeight(id);
            }, 5000);
          }
        },
        (err) => {
          this.time7 && clearTimeout(this.time7);
          this.time7 = setTimeout(() => {
            this.getmaterialsWeight(id);
          }, 5000);
        }
      );
    },
    getfeedTemp(id) {
      getfeedTemp(id).then(
        (res) => {
          if (res.data.code == 200) {
            this.feedTem = res.data.data;
            // console.log(res);
            this.time8 && clearTimeout(this.time8);
            this.time8 = setTimeout(() => {
              this.getfeedTemp(id);
            }, 5000);
          } else {
            this.time8 && clearTimeout(this.time8);
            this.time8 = setTimeout(() => {
              this.getfeedTemp(id);
            }, 5000);
          }
        },
        (err) => {
          this.time8 && clearTimeout(this.time8);
          this.time8 = setTimeout(() => {
            this.getfeedTemp(id);
          }, 5000);
        }
      );
    },
    handleChange(value) {
      console.log(value);
      this.id = value;
      this.getmaterialsWeight(this.id);
      this.getfeedTemp(this.id);
      this.getstoneTemp(this.id);
      this.getproductionInfo(this.id);
      this.getworkshopTemp(this.id);
      this.getrelatedInfo(this.id);
      this.getflueTemp(this.id);
      this.getbottleWeight(this.id);
      this.gethistogram(this.id);
      this.getelectricity(this.id);
      this.getmaterialUse(this.id);
    },
    smallScreen() {
      var el = document;
      var cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        //for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    fullScreen() {
      let elem = document.querySelector(".wrapper");
      let requestMethod =
        elem.requestFullScreen ||
        elem.webkitRequestFullScreen ||
        elem.mozRequestFullScreen ||
        elem.msRequestFullScreen;
      console.log(requestMethod);
      if (requestMethod) {
        requestMethod.call(elem);
      } else if (typeof window.ActiveXObject !== "undefined") {
        let wscript = new window.ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    fshandler() {
      let flag = !this.screenFlag;
      this.screenFlag = flag;
    },
  },
};
</script>
<style scoped>
.wrapper {
  width: 100%;
  background-color: #141f29;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.HeaderTop img {
  width: 1800px;
  height: 480px;
}
.HeaderTop {
  width: 100%;
  margin-top: 10px;
}
.img {
  border: 1px solid #184165;
  margin: 0px 20px;
  position: relative;
}
.relatedProduct {
  position: absolute;
  top: 55px;
  left: 50px;
  z-index: 10;
  height: 80px;
  font-size: 10px;
}
.input {
  display: flex;
  align-items: center;
}
.stove {
  width: 40px;
}
.contentTop {
  display: flex;
  color: #c8c9cd;
  justify-content: space-between;
  background-color: #1f2b39;
  margin: 20px;
  height: 60px;
  align-items: center;
}
.factoryName {
  font-size: 28px;
  padding-left: 10px;
}
.factoryName img {
  width: 20px;
  height: 25px;
}
.productEle {
  margin-top: 15px;
  width: 25%;
  height: 320px;
  border: 1px solid #3e3765;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.production {
  margin-top: 15px;
  width: 25%;
  height: 320px;
  border: 1px solid #3e3765;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.echartsTable {
  display: flex;
  width: 100%;
  padding: 0px 20px;
}
.fracking {
  margin-top: 15px;
  width: 25%;
  height: 320px;
  border: 1px solid #3e3765;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.info {
  width: 25%;
  margin-right: 10px;
}
.stone {
  display: flex;
  width: 100px;
  justify-content: space-around;
  height: 61px;
  font-weight: bold;
}
.stoneName {
  width: 5px;
  /* height: 15px;
  line-height: 15px;
  letter-spacing: 12px; */
  margin-top: 15px;
}
.weight {
  width: 25px;
}
.info {
  display: flex;
  align-items: center;
}
.type {
  width: 1px;
  padding-left: 22px;
}
.leftBottom {
  font-size: 10px;
  font-weight: bold;
}
.contentMiddle {
  font-size: 10px;
  font-weight: bold;
}
.inanity {
  position: absolute;
  top: 23%;
  left: 32.5%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.kerosence {
  position: absolute;
  top: 23%;
  left: 36%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.inanity1 {
  position: absolute;
  top: 38.5%;
  left: 32.5%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.kerosence1 {
  position: absolute;
  top: 38.5%;
  left: 36%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.inanity2 {
  position: absolute;
  top: 54%;
  left: 32.5%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.kerosence2 {
  position: absolute;
  top: 54%;
  left: 36%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.inanity3 {
  position: absolute;
  top: 69%;
  left: 32.5%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.kerosence3 {
  position: absolute;
  top: 69%;
  left: 36%;
  width: 65px;
  height: 45px;
  font-size: 10px;
  font-weight: bold;
}
.tem1 {
  width: 100px;
  height: 25px;
  background-color: #fff3c5;
  border: 1px solid #f5c04f;
}
.tem2 {
  width: 100px;
  height: 25px;
  background-color: #fff3c5;
  border: 1px solid #f5c04f;
}
.companyText {
  width: 100px;
  height: 25px;
  color: #fff;
}
.companyTem {
  position: absolute;
  top: 10%;
  left: 45%;
  font-size: 10px;
  font-weight: bold;
}
.kilnPress {
  position: absolute;
  top: 35%;
  left: 43.5%;
}
.fluidHight {
  position: absolute;
  top: 35%;
  left: 47%;
}
.dissolve {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 50%;
  left: 43.5%;
}
.dissolveName {
  color: #fff;
}
.clear {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 50%;
  left: 47.5%;
}
.clearName {
  color: #fff;
}
.avefeeding {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 72%;
  left: 42.5%;
}
.temNum {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 72%;
  left: 48%;
}
.lastTem {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 55%;
  left: 51%;
}
.feedingDetail1 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 18%;
  left: 52.5%;
  font-size: 10px;
  color: #f01515;
}
.runRev1 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 13.5%;
  left: 55.5%;
}
.runRev2 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 33.5%;
  left: 55.5%;
}
.runRev3 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 60.5%;
  left: 55.5%;
}
.runRev4 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 82.5%;
  left: 55.5%;
}
.currentDetail1 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 16.5%;
  left: 63.5%;
}
.currentDetail2 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 35.5%;
  left: 63.5%;
}
.currentDetail3 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 54.5%;
  left: 63.5%;
}
.currentDetail4 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 75.5%;
  left: 63.5%;
}
.frequency0 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 2%;
  left: 100%;
}
.frequency1 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 27%;
  left: 100%;
}
.frequency2 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 50%;
  left: 100%;
}
.frequency3 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 77%;
  left: 100%;
}
/* .frequency4 {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 78%;
  left: 85.5%;
} */
.bottleWeight {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 20%;
  left: 73%;
}
.itemWeight0 {
  height: 95px;
  width: 55px;
}
.itemWeight1 {
  height: 90px;
  width: 55px;
}
.itemWeight2 {
  height: 102px;
  width: 55px;
}
.itemWeight3 {
  height: 95px;
  width: 55px;
}
.itemState0 {
  height: 95px;
  width: 55px;
  color: #ebaa29;
}
.itemState1 {
  height: 125px;
  width: 55px;
  color: #ebaa29;
}
.itemState2 {
  height: 105px;
  width: 55px;
  color: #ebaa29;
}
.itemState3 {
  height: 105px;
  width: 55px;
  color: #ebaa29;
}
.currentState {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  top: 15.5%;
  left: 76.5%;
}
.packingNum {
  position: absolute;
  top: 22%;
  right: 11.5%;
  font-size: 10px;
  font-weight: bold;
}
.packingDetail {
  margin-left: 5px;
}
.productInfo {
  position: absolute;
  top: 12.5%;
  right: 3%;
}
.productItem {
  width: 80px;
  font-size: 10px;
  font-weight: bold;
  height: 25px;
}
.productName {
  color: #fff;
}
.BPM0 {
  height: 95px;
}
.BPM1 {
  height: 135px;
}
.BPM2 {
  height: 100px;
}
.BPM3 {
  height: 100px;
}
.itempackingNum0 {
  display: flex;
  height: 95px;
  width: 130px;
  color: #4e4a89;
}
.itempackingNum1 {
  display: flex;
  height: 60px;
  width: 130px;
  color: #4e4a89;
}
.itempackingNum2 {
  display: flex;
  height: 105px;
  width: 130px;
  color: #4e4a89;
}
.itempackingNum3 {
  display: flex;
  height: 95px;
  width: 130px;
  color: #4e4a89;
}
.itemFeed0 {
  height: 95px;
}
.itemFeed1 {
  height: 90px;
}
.itemFeed2 {
  height: 105px;
}
.itemFeed3 {
  height: 95px;
}
.stoveTem0 {
  padding-left: 5px;
  height: 95px;
}
.stoveTem1 {
  padding-left: 5px;
  height: 90px;
}
.stoveTem2 {
  padding-left: 5px;
  height: 105px;
}
.stoveTem3 {
  padding-left: 5px;
  height: 95px;
}
.annotation {
  color: #fff;
  font-weight: bold;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
}
.dateInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/factorystatus.vue